import type { ReactElement } from "react";

export function YourImages(): ReactElement {
  return (
    <>
      <h2>The library</h2>
      <p>
        Every image you have generated or uploaded appears in the library as one contact sheet,
        newest first. Search matches the prompt the image was made from, and you can filter by the
        model that made it or by whether you generated it or uploaded it.
      </p>
      <p>
        The sheet loads a page at a time. <strong>Load more</strong> fetches the next one; the model
        filter offers the models present in what has loaded so far.
      </p>

      <h2>Opening an image</h2>
      <p>
        Clicking a cell opens the full-size image with its prompt, model, dimensions, file size and
        date, a download link, and a link back to the board it came from.
      </p>

      <h2>What deleting removes</h2>
      <p>
        Deleting an image removes the file and its thumbnail permanently. It does not remove the
        board, and it does not remove the frame that produced the image — the prompt, model and
        parameters stay in the board's history.
      </p>
      <p>
        The other direction holds too: deleting a frame from a board removes the frame, and the
        images it produced stay in your library.
      </p>

      <h2>Why an image sometimes cannot be deleted</h2>
      <p>
        If an image was used as an input to a generation, Darkroom refuses to delete it and says so.
        Removing it would leave that frame claiming an input that no longer exists, and the lineage
        would be a dead link.
      </p>
      <p>
        To remove it anyway, delete the frames that used it first. Darkroom shows the server's own
        explanation, so the message you get is the reason it was refused.
      </p>
    </>
  );
}
